import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);
export default new Router({
	routes: [{
		path: '/classHealthDetail',
		name: 'classHealthDetail',
		component: function component(resolve) {
			require(['../components/health/classHealthDetail'], resolve);
		}
	}, {
		path: '/healthMng',
		name: 'healthMng',
		component: function component(resolve) {
			require(['../components/health/healthMng'], resolve);
		}
	}, {
		path: '/healthDetail',
		name: 'healthDetail',
		component: function component(resolve) {
			require(['../components/health/healthDetail'], resolve);
		}
	}, {
		path: '/healthList',
		name: 'healthList',
		component: function component(resolve) {
			require(['../components/health/healthList'], resolve);
		}
	}, {
		path: '/reportHealth',
		name: 'reportHealth',
		component: function component(resolve) {
			require(['../components/health/reportHealth'], resolve);
		}
	}, {
		path: '/opinion',
		name: 'opinion',
		component: function component(resolve) {
			require(['../components/opinion/opinion'], resolve);
		}
	}, {
		path: '/applyDetail',
		name: '/applyDetail',
		component: function component(resolve) {
			require(['../components/switchApply/applyDetail'], resolve);
		}
	}, {
		path: '/pubApply',
		name: 'pubApply',
		component: function component(resolve) {
			require(['../components/switchApply/pubApply'], resolve);
		}
	}, {
		path: '/applyList',
		name: 'applyList',
		component: function component(resolve) {
			require(['../components/switchApply/applyList'], resolve);
		}
	}, {
		path: '/zyxq',
		name: 'zyxq',
		component: function component(resolve) {
			require(['../components/homework/zyxq'], resolve);
		}
	}, {
		path: '/tjzy',
		name: 'tjzy',
		component: function component(resolve) {
			require(['../components/homework/tjzy'], resolve);
		}
	}, {
		path: '/fsd',
		name: 'fsd',
		component: function component(resolve) {
			require(['../components/msg/fsd'], resolve);
		}
	}, {
		path: '/kqtxl',
		name: 'kqtxl',
		component: function component(resolve) {
			require(['../components/attendance/kqtxl'], resolve);
		}
	}, {
		path: '/potho',
		name: 'potho',
		component: function component(resolve) {
			require(['../components/msg/potho'], resolve);
		}
	}, {
		path: '/jtbk',
		name: 'jtbk',
		component: function component(resolve) {
			require(['../components/msg/jtbk'], resolve);
		}
	}, {
		path: '/tzxq',
		name: 'tzxq',
		component: function component(resolve) {
			require(['../components/msg/tzxq'], resolve);
		}
	}, {
		path: '/xstxl',
		name: 'xstxl',
		component: function component(resolve) {
			require(['../components/contacts/xstxl'], resolve);
		}
	}, {
		path: '/xzbj',
		name: 'xzbj',
		component: function component(resolve) {
			require(['../components/class/xzbj'], resolve);
		}
	}, {
		path: '/txl_xq',
		name: 'txl_xq',
		component: function component(resolve) {
			require(['../components/contacts/txl_xq'], resolve);
		}
	}, {
		path: '/phone',
		name: 'phone',
		component: function component(resolve) {
			require(['../components/contacts/phone'], resolve);
		}
	}, {
		path: '/jstxl',
		name: 'jstxl',
		component: function component(resolve) {
			require(['../components/contacts/jstxl'], resolve);
		}
	}, {
		path: '/sctz',
		name: 'sctz',
		component: function component(resolve) {
			require(['../components/msg/sctz'], resolve);
		}
	}, {
		path: '/sczy_t',
		name: 'sczy_t',
		component: function component(resolve) {
			require(['../components/homework/sczy_t'], resolve);
		}
	}, {
		path: '/fbzy',
		name: 'fbzy',
		component: function component(resolve) {
			require(['../components/homework/fbzy'], resolve);
		}
	}, {
		path: '/ckmsg',
		name: 'ckmsg',
		component: function component(resolve) {
			require(['../components/msg/ckmsg'], resolve);
		}
	}, {
		path: '/xtmsg',
		name: 'xtmsg',
		component: function component(resolve) {
			require(['../components/msg/xtmsg'], resolve);
		}
	}, {
		path: '/homework',
		name: 'homework',
		component: function component(resolve) {
			require(['../components/homework/homework'], resolve);
		}
	}, {
		path: '/pgzy',
		name: 'pgzy',
		component: function component(resolve) {
			require(['../components/homework/pgzy'], resolve);
		}
	}, {
		path: '/pgtp',
		name: 'pgtp',
		component: function component(resolve) {
			require(['../components/homework/pgtp'], resolve);
		}
	}, {
		path: '/pgxq',
		name: 'pgxq',
		component: function component(resolve) {
			require(['../components/homework/pgxq'], resolve);
		}
	}, {
		path: '/yxzylist',
		name: 'yxzylist',
		component: function component(resolve) {
			require(['../components/homework/yxzylist'], resolve);
		}
	}, {
		path: '/yxzy',
		name: 'yxzy',
		component: function component(resolve) {
			require(['../components/homework/yxzy'], resolve);
		}
	}, {
		path: '/attendance_xq',
		name: 'attendance_xq',
		component: function component(resolve) {
			require(['../components/attendance/attendance_xq'], resolve);
		}
	}, {
		path: '/variable',
		name: 'variable',
		component: function component(resolve) {
			require(['../components/eleSubj/variable'], resolve);
		}
	}, {
		path: '/family',
		name: 'family',
		component: function component(resolve) {
			require(['../components/myinfo/family'], resolve);
		}
	}, {
		path: '/relation',
		name: 'relation',
		component: function component(resolve) {
			require(['../components/myinfo/relation'], resolve);
		}
	}, {
		path: '/love',
		name: 'love',
		component: function component(resolve) {
			require(['../components/myinfo/love'], resolve);
		}
	}, {
		path: '/teachter',
		name: 'teachter',
		component: function component(resolve) {
			require(['../components/class/teachter'], resolve);
		}
	}, {
		path: '/stu',
		name: 'stu',
		component: function component(resolve) {
			require(['../components/class/stu'], resolve);
		}
	}, {
		path: '/kcbxq',
		name: 'kcbxq',
		component: function component(resolve) {
			require(['../components/homework/kcbxq'], resolve);
		}
	}, {
		path: '/yxkq',
		name: 'yxkq',
		component: function component(resolve) {
			require(['../components/homework/yxkq'], resolve);
		}
	}, {
		path: '/curriculum',
		name: 'curriculum',
		component: function component(resolve) {
			require(['../components/curriculum'], resolve);
		}
	}, {
		path: '/variable_p',
		name: 'variable_p',
		component: function component(resolve) {
			require(['../components/eleSubj/variable_p'], resolve);
		}
	}, {
		path: '/variable_xq',
		name: 'variable_xq',
		component: function component(resolve) {
			require(['../components/eleSubj/variable_xq'], resolve);
		}
	}, {
		path: '/myclass',
		name: 'myclass',
		component: function component(resolve) {
			require(['../components/class/myclass'], resolve);
		}
	}, {
		path: '/myclass_xq',
		name: 'myclass_xq',
		component: function component(resolve) {
			require(['../components/class/myclass_xq'], resolve);
		}
	}, {
		path: '/course',
		name: 'course',
		component: function component(resolve) {
			require(['../components/eleSubj/course'], resolve);
		}
	}, {
		path: '/profile',
		name: 'profile',
		component: function component(resolve) {
			require(['../components/myinfo/profile'], resolve);
		}
	}, {
		path: '/newpass',
		name: 'newpass',
		component: function component(resolve) {
			require(['../components/myinfo/newpass'], resolve);
		}
	}, {
		path: '/info',
		name: 'info',
		component: function component(resolve) {
			require(['../components/myinfo/user_info'], resolve);
		}
	}, {
		path: '/',
		name: 'login',
		component: function component(resolve) {
			require(['../components/autologin'], resolve);
		}
	}, {
		path: '/attendance',
		name: 'attendance',
		component: function component(resolve) {
			require(['../components/attendance/attendance'], resolve);
		}
	}, {
		path: '/index',
		name: 'index',
		component: function component(resolve) {
			require(['../components/msg/index'], resolve);
		}
	}, {
		path: '/app',
		name: 'app',
		component: function component(resolve) {
			require(['../components/app'], resolve);
		}
	}, {
		path: '/user',
		name: 'user',
		component: function component(resolve) {
			require(['../components/myinfo/user'], resolve);
		}
	}, {
		path: '/timeStatistics',
		name: 'timeStatistics',
		component: function component(resolve) {
			require(['../components/classHour/timeStatistics'], resolve);
		}
	}, {
		path: '/newCol',
		name: 'newCol',
		component: function component(resolve) {
			require(['../components/classHour/newCol'], resolve);
		}
	}, {
		path: '/bindUser',
		name: 'bindUser',
		component: function component(resolve) {
			require(['../components/bind/bindUser'], resolve);
		}
	}, {
		path: '/bindStudent',
		name: 'bindStudent',
		component: function component(resolve) {
			require(['../components/bind/bindStudent'], resolve);
		}
	}, {
		path: '/bindTeacher',
		name: 'bindTeacher',
		component: function component(resolve) {
			require(['../components/bind/bindTeacher'], resolve);
		}
	}, {
		path: '/examMng',
		name: 'examMng',
		component: function component(resolve) {
			require(['../components/exam/examMng'], resolve);
		}
	}, {
		path: '/examStuDetail',
		name: 'examStuDetail',
		component: function component(resolve) {
			require(['../components/exam/examStuDetail'], resolve);
		}
	}, {
		path: '/examTeacherDetail',
		name: 'examTeacherDetail',
		component: function component(resolve) {
			require(['../components/exam/examTeacherDetail'], resolve);
		}
	}, {
		path: '/myGrade',
		name: 'myGrade',
		component: function component(resolve) {
			require(['../components/grade/myGrade'], resolve);
		}
	}, {
		path: '/gradeTeacherDetail',
		name: 'gradeTeacherDetail',
		component: function component(resolve) {
			require(['../components/grade/gradeTeacherDetail'], resolve);
		}
	}, {
		path: '/gradeStuDetail',
		name: 'gradeStuDetail',
		component: function component(resolve) {
			require(['../components/grade/gradeStuDetail'], resolve);
		}
	}, {
		path: '/publicGrade',
		name: 'publicGrade',
		component: function component(resolve) {
			require(['../components/grade/publicGrade'], resolve);
		}
	}, {
		path: '/publicResult',
		name: 'publicResult',
		component: function component(resolve) {
			require(['../components/grade/publicResult'], resolve);
		}
	}, {
		path: '/gradeAnalyse',
		name: 'gradeAnalyse',
		component: function component(resolve) {
			require(['../components/grade/gradeAnalyse'], resolve);
		}
	}, {
		path: '/evalList',
		name: 'evalList',
		component: function component(resolve) {
			require(['../components/evalTeacher/evalList'], resolve);
		}
	}, {
		path: '/evalDetail',
		name: 'evalDetail',
		component: function component(resolve) {
			require(['../components/evalTeacher/evalDetail'], resolve);
		}
	}, {
		path: '/evalReport',
		name: 'evalReport',
		component: function component(resolve) {
			require(['../components/evalTeacher/evalReport'], resolve);
		}
	}, {
		path: '/reportSuccess',
		name: 'reportSuccess',
		component: function component(resolve) {
			require(['../components/evalTeacher/reportSuccess'], resolve);
		}
	}, {
		path: '/bindLogin',
		name: 'bindLogin',
		component: function component(resolve) {
			require(['../components/bind/bindLogin'], resolve);
		}
	}, {
		path: '/susuan',
		name: 'susuan',
		component: function component(resolve) {
			require(['../components/xunfei/susuan'], resolve);
		}
	}, {
		path: '/xunfeiocr',
		name: 'xunfeiocr',
		component: function component(resolve) {
			require(['../components/xunfei/ocr'], resolve);
		}
	}, {
		path: '/imageTranslate',
		name: 'imageTranslate',
		component: function component(resolve) {
			require(['../components/youdao/imageTranslate'], resolve);
		}
	}, {
		path: '/questionOcr',
		name: 'questionOcr',
		component: function component(resolve) {
			require(['../components/youdao/questionOcr'], resolve);
		}
	}, {
		path: '/bindLogin1',
		name: 'bindLogin1',
		component: function component(resolve) {
			require(['../components/bind/bindLogin1'], resolve);
		}
	}, {
		path: '/bindLogin2',
		name: 'bindLogin2',
		component: function component(resolve) {
			require(['../components/bind/bindLogin2'], resolve);
		}
	}, {
		path: '/eleCourse',
		name: 'eleCourse',
		component: function component(resolve) {
			require(['../components/eleCourse/eleCourse'], resolve);
		}
	}, {
		path: '/eleTaskDetail',
		name: 'eleTaskDetail',
		component: function component(resolve) {
			require(['../components/eleCourse/taskDetail'], resolve);
		}
	}, {
		path: '/eleCourseList',
		name: 'eleCourseList',
		component: function component(resolve) {
			require(['../components/eleCourse/courseList'], resolve);
		}
	}, {
		path: '/eleCourseDetail',
		name: 'eleCourseDetail',
		component: function component(resolve) {
			require(['../components/eleCourse/courseDetail'], resolve);
		}
	}, {
		path: '/psyApoint',
		name: 'psyApoint',
		component: function component(resolve) {
			require(['../components/psy/psyApoint'], resolve);
		}
	}, {
		path: '/psyApointList',
		name: 'psyApointList',
		component: function component(resolve) {
			require(['../components/psy/psyApointList'], resolve);
		}
	}, {
		path: '/teacherPsyApointList',
		name: 'teacherPsyApointList',
		component: function component(resolve) {
			require(['../components/psy/teacherPsyApointList'], resolve);
		}
	}, {
		path: '/learningList',
		name: 'learningList',
		component: function component(resolve) {
			require(['../components/learning/learningList'], resolve);
		}
	}, {
		path: '/learningSubjectList',
		name: 'learningSubjectList',
		component: function component(resolve) {
			require(['../components/learning/learningSubjectList'], resolve);
		}
	}, {
		path: '/learningSubjectDetail',
		name: 'learningSubjectDetail',
		component: function component(resolve) {
			require(['../components/learning/learningSubjectDetail'], resolve);
		}
	}, {
		path: '/studentEvalList',
		name: 'studentEvalList',
		component: function component(resolve) {
			require(['../components/evalStudent/studentEvalList'], resolve);
		}
	}, {
		path: '/studentEvalDetail',
		name: 'studentEvalDetail',
		component: function component(resolve) {
			require(['../components/evalStudent/studentEvalDetail'], resolve);
		}
	}, {
		path: '/studentEvalDevelopForm',
		name: 'studentEvalDevelopForm',
		component: function component(resolve) {
			require(['../components/evalStudent/studentEvalDevelopForm'], resolve);
		}
	}, {
		path: '/studentEvalBaseForm',
		name: 'studentEvalBaseForm',
		component: function component(resolve) {
			require(['../components/evalStudent/studentEvalBaseForm'], resolve);
		}
	}, {
		path: '/studentEvalMoralForm',
		name: 'studentEvalMoralForm',
		component: function component(resolve) {
			require(['../components/evalStudent/studentEvalMoralForm'], resolve);
		}
	}, {
		path: '/studentEvalMoralList',
		name: 'studentEvalMoralList',
		component: function component(resolve) {
			require(['../components/evalStudent/studentEvalMoralList'], resolve);
		}
	}, {
		path: '/studentEvalTeacherList',
		name: 'studentEvalTeacherList',
		component: function component(resolve) {
			require(['../components/evalStudent/studentEvalTeacherList'], resolve);
		}
	}, {
		path: '/studentEvalTeacherDetail',
		name: 'studentEvalTeacherDetail',
		component: function component(resolve) {
			require(['../components/evalStudent/studentEvalTeacherDetail'], resolve);
		}
	}, {
		path: '/studentEvalTeacherComment',
		name: 'studentEvalTeacherComment',
		component: function component(resolve) {
			require(['../components/evalStudent/studentEvalTeacherComment'], resolve);
		}
	}, {
		path: '/studentEvalTeacherDomainsList',
		name: 'studentEvalTeacherDomainsList',
		component: function component(resolve) {
			require(['../components/evalStudent/studentEvalTeacherDomainsList'], resolve);
		}
	}, {
		path: '/studentEvalTeacherDomainsDetail',
		name: 'studentEvalTeacherDomainsDetail',
		component: function component(resolve) {
			require(['../components/evalStudent/studentEvalTeacherDomainsDetail'], resolve);
		}
	}, {
		path: '/studentEvalTeacherScoreList',
		name: 'studentEvalTeacherScoreList',
		component: function component(resolve) {
			require(['../components/evalStudent/studentEvalTeacherScoreList'], resolve);
		}
	}, {
		path: '/studentEvalTeacherScoreDetail',
		name: 'studentEvalTeacherScoreDetail',
		component: function component(resolve) {
			require(['../components/evalStudent/studentEvalTeacherScoreDetail'], resolve);
		}
	}]
});


// WEBPACK FOOTER //
// ./src/router/index.js